import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=2352c3b2&scoped=true"
import script from "./CheckPage.vue?vue&type=script&lang=js"
export * from "./CheckPage.vue?vue&type=script&lang=js"
import style0 from "./CheckPage.vue?vue&type=style&index=0&id=2352c3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352c3b2",
  null
  
)

export default component.exports